import { JobSeekingStatus } from "@nimble/core-client/types";

import { MobileTrigger } from "@/components/shared/job-seeking-status-dropdown/job-seeking-status-components";
import { JobseekingStatusDropdown } from "@/components/shared/job-seeking-status-dropdown/job-seeking-status-dropdown";
import ResponseErrorDialog from "@/components/shared/response-error-dialog/response-error-dialog";

export default function JobSeekingStatusHeaderView({
  value,
  onChange,
  isPending,
  error,
  reset,
}: {
  value: JobSeekingStatus;
  onChange: (newValue: JobSeekingStatus) => void;
  isPending: boolean;
  error?: Error | null;
  reset: () => void;
}) {
  return (
    <div className="w-auto">
      <JobseekingStatusDropdown
        value={value}
        onChange={onChange}
        loading={isPending}
        TriggerComponent={MobileTrigger}
      />
      {error && <ResponseErrorDialog error={error} onClose={reset} />}
    </div>
  );
}
